// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dancing-dots":"dancing-dots___yaQUL","dancing-dots-jump":"dancing-dots-jump___2XEei","one":"one___1n2_S","two":"two___1KCdg","three":"three___3YRif"};